module.exports = __webpack_public_path__ + "img/transfer.a2ccfccb.svg";